export default __webpack_public_path__ + "static/media/Tomiheadshot.cbb9078f.jpg";